/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Onh_MoreInputs */

const en_wc_onh_more = /** @type {(inputs: Wc_Onh_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the online getting-started guide`)
};

/**
* | output |
* | --- |
* | "Read the online getting-started guide" |
*
* @param {Wc_Onh_MoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_onh_more = /** @type {((inputs?: Wc_Onh_MoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Onh_MoreInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_onh_more(inputs)
});
export { wc_onh_more as "wc.onh.more" }